// PANTALLA 0.1 — El Equipamiento (qué ofrecemos)
// Copy: ../lobbyContent.js → LOBBY_EQUIPMENT*
//
// El gancho es la capacidad instalada del gimnasio, no una promesa de tiempo.
// Cada tarjeta corresponde a una función que existe hoy en el producto (el
// campo `evidence` de lobbyContent.js documenta dónde vive cada una).
import {
  LOBBY_EQUIPMENT_INTRO,
  LOBBY_EQUIPMENT,
  LOBBY_EQUIPMENT_CLOSING,
  LOBBY_EQUIPMENT_CTA,
} from '../lobbyContent';

export default function LobbyEquipamiento({ onNext, onBack }) {
  return (
    <div className="ob-screen ob-ancho">
      <button type="button" className="ob-back" onClick={onBack}>
        ← Volver
      </button>

      <p className="ob-eyebrow">{LOBBY_EQUIPMENT_INTRO.eyebrow}</p>
      <h1 className="ob-headline">
        {LOBBY_EQUIPMENT_INTRO.headline}{' '}
        <span className="ob-bloque">{LOBBY_EQUIPMENT_INTRO.headlineBloque}</span>
      </h1>
      <p className="ob-body">{LOBBY_EQUIPMENT_INTRO.subheadline}</p>

      <div className="ob-gear-grid">
        {LOBBY_EQUIPMENT.map((item, i) => (
          <article
            key={item.title}
            className="ob-gear"
            // Entrada escalonada: cada tarjeta aparece 60ms después de la anterior.
            style={{ animationDelay: `${i * 0.06}s` }}
          >
            <span className="ob-gear-icon" aria-hidden="true">{item.icon}</span>
            <h2 className="ob-gear-title">{item.title}</h2>
            <p className="ob-gear-text">{item.text}</p>
          </article>
        ))}
      </div>

      {/* Cierre anti-humo: el corazón del posicionamiento */}
      <p className="ob-honesty ob-honesty-strong">{LOBBY_EQUIPMENT_CLOSING}</p>

      <div className="ob-actions">
        <button type="button" className="ob-btn" onClick={onNext}>
          {LOBBY_EQUIPMENT_CTA}
        </button>
      </div>
    </div>
  );
}
